import React, { useState, useEffect, useRef, useCallback } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import api from '../api/api';

export const TabelaRelatorioComercio = () => {
    const [dados, setDados] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const toast = useRef(null);
    const [sortable, setSortable] = useState('ASC');

    const getData = useCallback(async () => {
        setIsLoading(true);
        setDados([]);

        try {
            const response = await api.get('produtos-comercializados');
            setDados(response.data);
            setTotalRecords(response.data.length);
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Erro ao obter dados', detail: error.toString() });
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        const fetchDados = async () => {
            try {
                await getData();
            } catch (error) {
                toast.current.show({ severity: 'error', summary: 'Erro', detail: error.toString() });
            }
        };
        fetchDados();
    }, [getData]);

    const header = <h2>Comercializado</h2>;

    const boletimBodyTemplate = (rowData) => <span>{rowData.boletimId}</span>;

    const produtoBodyTemplate = (rowData) => <span>{rowData.nomeProduto}</span>;

    const quantidadeEstimadaBodyTemplate = (rowData) => <span>{rowData.quantidadeEstimada}</span>;

    const quantidadeComercializadaBodyTemplate = (rowData) => <span>{rowData.quantidadeComercializada}</span>;

    const porcentagemComercializadaBodyTemplate = (rowData) => (
        <span>{(rowData.porcentagemComercializada * 100).toFixed(2)}%</span>
    );

    const produtorBodyTemplate = (rowData) => <span>{rowData.nomeProdutor}</span>;

    const dataEmissaoBodyTemplate = (rowData) => {
        const date = new Date(rowData.dataEmissao);
        return <span>{date.toLocaleDateString('pt-BR', { year: 'numeric', month: '2-digit', day: '2-digit' })}</span>;
    };

    const fimColheitaBodyTemplate = (rowData) => {
        const date = new Date(rowData.fimColheita);
        return <span>{date.toLocaleDateString('pt-BR', { year: 'numeric', month: '2-digit', day: '2-digit' })}</span>;
    };

    return (
        <>
            <Toast ref={toast} />
            <div className="p-fluid">
                <DataTable
                    className="p-datatable-responsive-demo"
                    value={dados}
                    paginator
                    rows={15}
                    totalRecords={totalRecords}
                    loading={isLoading}
                    header={header}
                    emptyMessage="Nenhum dado encontrado."
                    responsiveLayout="scroll"
                >
                    <Column
                        field="boletimId"
                        sortable={sortable}
                        header="Boletim"
                        body={boletimBodyTemplate}
                        filterMatchMode="boletimId"
                    />
                    <Column field="nomeProduto" sortable={sortable} header="Produto" body={produtoBodyTemplate} />
                    <Column field="quantidadeEstimada" sortable={sortable} header="Qtd. Estimada" body={quantidadeEstimadaBodyTemplate} />
                    <Column field="quantidadeComercializada" sortable={sortable} header="Qtd. Comercializada" body={quantidadeComercializadaBodyTemplate} />
                    <Column
                        field="porcentagemComercializada"
                        header="% Comercializada"
                        sortable={sortable}
                        body={porcentagemComercializadaBodyTemplate}
                    />
                    <Column field="nomeProdutor" sortable={sortable} header="Produtor" body={produtorBodyTemplate} />
                    <Column
                        field="dataEmissao"
                        header="Data Emissão"
                        sortable={sortable}
                        body={dataEmissaoBodyTemplate}
                    />
                    <Column
                        field="fimColheita"
                        header="Fim Colheita"
                        sortable={sortable}
                        body={fimColheitaBodyTemplate}
                    />
                </DataTable>
            </div>
        </>
    );
};
